export default __webpack_public_path__ + "b01d8dd244359b28de342c8d60e60f0e.png";